import { Button } from '../../common'
import useDebugExitZone from './useDebugExitZone'

interface DebugExitZoneProps {
  mode?: 'debug' | 'default'
}

const DebugExitZone = (props: DebugExitZoneProps) => {
  const { mode = 'default' } = props

  const { debugP2, handlers } = useDebugExitZone()
  const { handleExitZone, handleExitZoneAndDelete, handleClearServerCache } =
    handlers

  if (mode === 'default') {
    return (
      <>
        <Button onClick={handleExitZone}>Exit Zone</Button>
      </>
    )
  } else {
    return (
      <div
        style={{
          padding: '0 1%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {debugP2 && (
          <>
            <Button onClick={handleClearServerCache}>Clear Server Cache</Button>
            <Button onClick={handleExitZone}>Exit Zone</Button>
          </>
        )}
        <Button onClick={handleExitZoneAndDelete}>
          Exit Zone & Delete Dossier
        </Button>
      </div>
    )
  }
}

export default DebugExitZone
